<!-- Activity Tab Content Starts -->
<div class="activity-tab-content activityScrollableContainer" tabindex="0" (scroll)="this.onScrollDownActivity()">
  @if (fileInfoImpl.fileInfoActivityData.length==0 && isActivityLoaded==true) {
    <div class='empty-activity'>
    No activity to show</div>
  }
  <!-- Activity row starts -->
  @for (activity of fileInfoImpl.fileInfoActivityData; track activity; let i = $index) {
    <div >
      @if (activity.eventName != fileInfoImpl.noActivityEventLabel) {
        <div class="activity-inner">
          <span class="date mb-2">{{universalService.showTimeInFormat(activity.eventDate, textToAppend, fileInfoImpl.currentTimeToUse)}}</span>
          <div class="row ml-0 mt-0 mr-0 mb-2 pl-0 pt-0 pr-0 pb-0">
            <div class="col-2 pl-0 pt-0 pr-1 pb-0">
              <!-- DP -->
              <div class="dp">
                <span class="icon-profile-holder NeueUserFilled mr-2"></span>
                <img [ngStyle]="{'background-size':'100%','background-image': attachKeysToPhoto(activity.actorProfilePic)}" alt="" class="img-fluid" />
              </div>
            </div>
            <div class="col-10 pl-0 pt-0 pr-0 pb-0">
              <h2>{{activity.template}}</h2>
              <div class="f-name">
                <span class="format-tile {{activity.formatClass}}"></span>
                <span class="activity-objectName" title={{activity.objectName}}>{{activity.objectName}}</span>
              </div>
            </div>
          </div>
        </div>
      }
      @if (activity.eventName == fileInfoImpl.noActivityEventLabel) {
        <div class="no-activity-inner">
          <div class="row ml-0 mt-0 mr-0 mb-3 pl-0 pt-0 pr-0 pb-0">
            <div class="col-10 pl-0 pt-0 pr-0 pb-0">
              <h2>{{activity.template}}</h2>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <!-- Activity row Ends -->
</div>
<!-- Activity Tab Content Ends -->
